/* eslint-disable max-lines-per-function */
import { track } from "jiffy-analytics";
import { on as onEvent } from "common/utils/ui/event";

const $getProductForm = () => document.querySelector(".js-product-details-quantity-form-product");
const $getActiveColor = () => document.getElementById("active-color-name");
const $getProductDetails = () =>
  document.querySelector(
    `#product-details-variants-form input[data-color="${$getActiveColor().value}"]`
  );

export const trackEvent = (event, additionalProps = {}) => {
  if (!$getActiveColor() || !$getProductDetails()) return;
  const { detailedProductName, compositionId, businessLine } = $getProductDetails().dataset ?? {};

  track(event, {
    ...additionalProps,
    page: window.location.href,
    product: detailedProductName,
    spree_composition_id: compositionId,
    product_id: $getProductForm()?.value,
    business_line: businessLine
  });
};

let isTopCloseIconBtn = false;
const initTopCloseIcon = () => {
  const callback = () => {
    isTopCloseIconBtn = true;
  };

  onEvent("click", ".js-product-comments-modal-top-close-btn", callback, true);
};

let isBottomCloseIconBtn = false;
const initBottomCloseIcon = () => {
  const callback = () => {
    isBottomCloseIconBtn = true;
  };

  onEvent("click", ".js-product-comments-modal-bottom-close-btn", callback, true);
};

export const trackHideModal = () => {
  let context = "outside_click";

  if (isTopCloseIconBtn) {
    context = "close_cross";
  } else if (isBottomCloseIconBtn) {
    context = "close_button";
  }

  isTopCloseIconBtn = false;
  isBottomCloseIconBtn = false;
  trackEvent("product_detail_post_you_question_modal_closed", { context });
};

export default () => {
  initTopCloseIcon();
  initBottomCloseIcon();
};
